// extracted by mini-css-extract-plugin
export var alignCenter = "_8o-d";
export var bannerShown = "_8o-6";
export var buttonContent = "_8o-0";
export var cardList = "_8o-1";
export var centerContent = "_8o-2";
export var chevron = "_8o-3";
export var closePanelButton = "_8o-k";
export var conversationContextContainer = "_8o-l";
export var conversationDetailContainer = "_8o-4";
export var detailWrapper = "_8o-7";
export var dropdownButton = "_8o-e";
export var dropdownTitle = "_8o-9";
export var fullHeight = "_8o-5";
export var hidden = "_8o-a";
export var icon = "_8o-b";
export var mergeSuggestionWrapper = "_8o-m";
export var panel = "_8o-i";
export var portalButtonsWrapper = "_8o-c";
export var right = "_8o-j";
export var tableSummaryContainer = "_8o-8";
export var tableSummaryHeader = "_8o-g";
export var threeDotsButton = "_8o-f";
export var wide = "_8o-h";